import React, { useState, useEffect } from "react";
import { useDropzone } from "react-dropzone";
import { api } from "../../../utils/Api";
import { Link, useParams } from "react-router-dom";
import { DefaultEditor } from "react-simple-wysiwyg";
import DropzoneModal from "./DropzoneModal";

let initial_value = {
  invoice_color_primary: "",
  invoice_heading_color: "",
  receipt_color_primary: "",
  receipt_color_secondary: "",
  invoice_notes: "",
};

export default function Account(props) {
  const { acceptedFiles, getRootProps, getInputProps } = useDropzone();
  const [id_value, SerIdValue] = useState(useParams());

  //
  const [image_sizes, SetImageSize] = useState([]);
  const [image_base_url, SetImageBaseUrl] = useState("");
  const [invoice_logo, SetInvoiceLogo] = useState({});
  const [receipt_logo, SetReceiptLogo] = useState({});
  const [signature_image, SetSignatureImage] = useState({});
  const [general_settings, SetGeneralSettings] = useState(initial_value);
  const [dropzone_modal, SetDropzoneModal] = useState({
    is_open: false,
    from: "",
  });

  const files = acceptedFiles.map((file) => (
    <li key={file.path}>
      {file.path} - {file.size} bytes
    </li>
  ));

  function onChange(e) {
    console.log(" onChange e:", e.target.value);
    SetExampleText(e.target.value);
  }

  useEffect(() => {
    console.log("Account Settings on mount:", props);
    get_account();
  }, []);

  async function get_account() {
    let pass_data = {
      get: {
        brand: id_value.brand_id,
      },
    };
    let response = await api("/brand/settings", pass_data);
    console.log("/brand/settings response :", response.response);
    if (response.status_code == 200) {
      if (response.response.hasOwnProperty("image_sizes")) {
        SetImageSize(response.response.image_sizes);
      }
      if (response.response.hasOwnProperty("image_base_url")) {
        SetImageBaseUrl(response.response.image_base_url);
      }
      if (response.response.hasOwnProperty("invoice_logo")) {
        if (response.response.invoice_logo != null) {
          SetInvoiceLogo(response.response.invoice_logo);
        }
      }
      if (response.response.hasOwnProperty("receipt_logo")) {
        if (response.response.receipt_logo != null) {
          SetReceiptLogo(response.response.receipt_logo);
        }
      }
      if (response.response.hasOwnProperty("signature_image")) {
        if (response.response.signature_image != null) {
          SetSignatureImage(response.response.signature_image);
        }
      }
      if (response.response.hasOwnProperty("general_settings")) {
        if (response.response.general_settings != null) {
          SetGeneralSettings(response.response.general_settings);
        }
      }
    }
  }

  function title_generate(title: any) {
    let replaced_data = title.replaceAll("_", " ");
    var splitStr = replaced_data.toLowerCase().split(" ");
    for (var i = 0; i < splitStr.length; i++) {
      splitStr[i] =
        splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
    }
    return splitStr.join(" ");
  }

  async function save_settings() {
    let pass_data = {
      get: {
        brand: id_value.brand_id,
      },
      post: general_settings,
    };
    let response = await api("/brand/save_settings", pass_data);
    console.log("/brand/save_settings response :", response.response);
    // tost
    if (response.status_code == 200) {
      if (response.response.hasOwnProperty("image_sizes")) {
        SetImageSize(response.response.image_sizes);
      }
      if (response.response.hasOwnProperty("image_base_url")) {
        SetImageBaseUrl(response.response.image_base_url);
      }
      if (response.response.hasOwnProperty("invoice_logo")) {
        if (response.response.invoice_logo != null) {
          SetInvoiceLogo(response.response.invoice_logo);
        }
      }
      if (response.response.hasOwnProperty("receipt_logo")) {
        if (response.response.receipt_logo != null) {
          SetReceiptLogo(response.response.receipt_logo);
        }
      }
      if (response.response.hasOwnProperty("signature_image")) {
        if (response.response.signature_image != null) {
          SetSignatureImage(response.response.signature_image);
        }
      }
      if (response.response.hasOwnProperty("general_settings")) {
        if (response.response.general_settings != null) {
          SetGeneralSettings(response.response.general_settings);
        }
      }
    }
  }

  return (
    <div>
      <div className="bg-fff py-3 px-4">
        <h5 className="mb-1 text-dark fw-bolder">Account Settings</h5>
      </div>
      <div className="container mt-md-4 p-3">
        <div className="card p-4">
          <div className="row">
            {/* Invoice image*/}
            <div className="col-12 col-sm-6 col-md-4 mb-3">
              {/* {invoice_edit ? (
                <div>
                  <div className="d-flex">
                    <label className="form-label">Select Invoice Logo</label>
                    <div
                      className="ms-auto cursor"
                      onClick={() => {
                        SetInvoiceEdit(false);
                      }}
                    >
                      Cancel
                    </div>
                  </div>
                  <section className="">
                    <div
                      {...getRootProps({
                        className:
                          "dropzone  h-50 border p-3 justify-content-center d-flex",
                      })}
                    >
                      <input {...getInputProps()} />
                      <p className="mb-0">Drag & Drop logo</p>
                    </div>
                    <aside className="mt-2">
                      <h6>Files</h6>
                      <ul>{files}</ul>
                    </aside>
                  </section>
                  <div className="mt-2 d-flex">
                    <button className="btn btn-blue-outline me-2 btn-sm">
                      Upload
                    </button>
                  </div>
                </div>
              ) : (
               null
              )} */}
              <div className="p-2 ">
                <div className="d-flex md-me-4">
                  <label className="form-label">Invoice Logo Image</label>
                  <div
                    className="ms-auto d-flex cursor me-2"
                    onClick={() => {
                      SetDropzoneModal((prevValue) => {
                        prevValue.is_open = true;
                        prevValue.from = "invoice_logo";
                        return { ...prevValue };
                      });
                    }}
                  >
                    <img
                      src={require("../../../assets/icon/svg/edit3-1.svg")}
                      className="action_menu_img"
                    />
                    edit
                  </div>
                </div>
                <div className="p-2 border text-center">
                  <img
                    src={
                      Object.keys(invoice_logo).length > 0
                        ? image_base_url +
                        image_sizes[0] +
                        "/" +
                        invoice_logo.url
                        : require("../../../assets/img/add.png")
                    }
                    className="account-img"
                  />
                </div>
              </div>
            </div>
            {/* Signature image*/}
            <div className="col-12 col-sm-6 col-md-4 mb-3">
              {/* {signature_edit ? (
                <div>
                  <div className="d-flex">
                    <label className="form-label">Select Signature Image</label>
                    <div
                      className="ms-auto cursor"
                      onClick={() => {
                        SetSignatureEdit(false);
                      }}
                    >
                      Cancel
                    </div>
                  </div>
                  <section className="">
                    <div
                      {...getRootProps({
                        className:
                          "dropzone  h-50 border p-3 justify-content-center d-flex",
                      })}
                    >
                      <input {...getInputProps()} />
                      <p className="mb-0">Drag & Drop logo</p>
                    </div>
                    <aside className="mt-2">
                      <h6>Files</h6>
                      <ul>{files}</ul>
                    </aside>
                  </section>
                  <div className="mt-2 d-flex">
                    <button className="btn btn-blue-outline me-2 btn-sm">
                      Upload
                    </button>
                  </div>
                </div>
              ) : (
                null
              )} */}
              <div className="p-2">
                <div className="d-flex md-me-4">
                  <label className="form-label">Signature Image</label>
                  <div
                    className="ms-auto d-flex cursor me-2"
                    onClick={() => {
                      SetDropzoneModal((prevValue) => {
                        prevValue.is_open = true;
                        prevValue.from = "signature_image";
                        return { ...prevValue };
                      });
                    }}
                  >
                    <img
                      src={require("../../../assets/icon/svg/edit3-1.svg")}
                      className="action_menu_img"
                    />
                    edit
                  </div>
                </div>
                <div className="border p-2 text-center">
                  <img
                    src={
                      Object.keys(signature_image).length > 0
                        ? image_base_url +
                        image_sizes[0] +
                        "/" +
                        signature_image.url
                        : require("../../../assets/img/add.png")
                    }
                    className="account-img"
                  />
                </div>
              </div>
            </div>
            {/* Receipt image*/}
            <div className="col-12 col-sm-6 col-md-4 mb-3">
              {/* {receipt_edit ? (
                <div>
                  <div className="d-flex">
                    <label className="form-label">Select Receipt Image</label>
                    <div
                      className="ms-auto cursor"
                      onClick={() => {
                        SetReceiptEdit(false);
                      }}
                    >
                      Cancel
                    </div>
                  </div>
                  <section className="">
                    <div
                      {...getRootProps({
                        className:
                          "dropzone  h-50 border p-3 justify-content-center d-flex",
                      })}
                    >
                      <input {...getInputProps()} />
                      <p className="mb-0">Drag & Drop logo</p>
                    </div>
                    <aside className="mt-2">
                      <h6>Files</h6>
                      <ul>{files}</ul>
                    </aside>
                  </section>

                  <div className="mt-2 d-flex">
                    <button className="btn btn-blue-outline me-2 btn-sm">
                      Upload
                    </button>
                  </div>
                </div>
              ) : (
                null
              )} */}
              <div className="p-2 ">
                <div className="d-flex md-me-4">
                  <label className="form-label">Receipt Logo Image</label>
                  <div
                    className="ms-auto d-flex cursor me-2"
                    onClick={() => {
                      SetDropzoneModal((prevValue) => {
                        prevValue.is_open = true;
                        prevValue.from = "receipt_logo";
                        return { ...prevValue };
                      });
                    }}
                  >
                    <img
                      src={require("../../../assets/icon/svg/edit3-1.svg")}
                      className="action_menu_img"
                    />
                    edit
                  </div>
                </div>
                <div className="border p-2 text-center">
                  <img
                    src={
                      Object.keys(receipt_logo).length > 0
                        ? image_base_url +
                        image_sizes[0] +
                        "/" +
                        receipt_logo.url
                        : require("../../../assets/img/add.png")
                    }
                    className="account-img"
                  />
                </div>
              </div>
            </div>
            {/* General Settings */}
            <p className="text-dark">General Settings </p>
            <div className="row mb-3">
              {Object.keys(general_settings).map((key: any, key_index: any) =>
                key == "invoice_color_primary" ||
                  key == "invoice_heading_color" ||
                  key == "receipt_color_primary" ||
                  key == "receipt_color_secondary" ? (
                  <div className="col-md-6 d-flex mb-2 " key={key_index}>
                    <label className="form-label">
                      {title_generate(key)} :
                    </label>
                    <input
                      type="color"
                      defaultValue={general_settings[key]}
                      value={general_settings[key]}
                      onChange={(e) => {
                        SetGeneralSettings((prevValue) => {
                          prevValue[key] = e.target.value;
                          return { ...prevValue };
                        });
                      }}
                      className="flex-basis-10 ms-auto form-control cursor rounded p-0"
                    />
                  </div>
                ) : null
              )}
            </div>
            <div className="my-2 p-0">
              <label className="form-label text-dark fw-bolder fs-6">GST %</label>
              <input
                className="form-control"
                type="number"
                value={general_settings.gst}
                onChange={(e) => {
                  console.log("Gst L", e.target.value);
                  SetGeneralSettings((prevValue) => {
                    prevValue.gst = e.target.value;
                    return { ...prevValue };
                  });
                }}
              />
            </div>
            <div className="my-2 p-0">
              <p className="text-dark fw-bolder fs-6">Invoice notes</p>
              <DefaultEditor
                value={general_settings.invoice_notes}
                onChange={(e) => {
                  SetGeneralSettings((prevValue) => {
                    prevValue.invoice_notes = e.target.value;
                    return { ...prevValue };
                  });
                }}
              />
            </div>

            <div className="text-end">
              <button
                className="btn btn-light-outline"
                onClick={() => {
                  console.log("Genearal Setting :", general_settings);
                  save_settings();
                }}
              >
                Save
              </button>
            </div>
          </div>
        </div>
      </div>

      <DropzoneModal
        is_open={dropzone_modal.is_open}
        from={dropzone_modal.from}
        close={(data) => {
          console.log("Dropzone Modal on close :", data);
          SetDropzoneModal((prevValue) => {
            prevValue.is_open = false;
            return { ...prevValue };
          });
          if (data.action == "save") {
            get_account();
          }
        }}
      />
    </div>
  );
}
